import '../util/Custom.css'
import consts from '../../../consts'
import { useViewSistema } from '../../../hooks/useView'

export function ViewNavTab(props){
    const { mudaView, removeView } = useViewSistema()
    return (
        <li>
            <div className="divTab">
                <a className={`nav-link ${(props.ativo ? 'active' : '')}`} id={`tab-menu-${props.chave}`}
                    data-toggle="pill" href={`#tab-${props.chave}`} role="tab"
                    aria-controls={`menu-${props.chave}`} aria-selected={props.ativo}
                    onClick={() => mudaView(props.chave)}>
                    <div>
                        <strong><i className={`fas fa-${props.icone} nav-icon`}></i> {props.nome}</strong>
                    </div>
                </a>
                {(((props.chave !== 'home') && (props.ativo)) ?
                    <a className="btnFecharTab pointer" href={consts.linkApp}
                        onClick={() => { removeView(props.chave) }}>
                        <i className="fas fa-times fa-sm text-danger"></i>
                    </a>
                    : null
                )}
            </div>
        </li>
    )
}